// extracted by mini-css-extract-plugin
export default {"container":"SideAppBar_container__tEZJV","openSideBar":"SideAppBar_openSideBar__FDjN5","closeSideBar":"SideAppBar_closeSideBar__bLOyv"};